import React from 'react';
const Select = React.memo((props) => {
    var _a;
    let classes = (_a = props.classes) !== null && _a !== void 0 ? _a : [];
    classes = ['focus:outline-none', 'focus:ring-2', 'focus:border-blue-300', 'rounded', ...classes];
    return (React.createElement("select", { className: classes.join(" "), name: props.name, value: props.value, onChange: props.onChange, disabled: props.disabled }, props.options.map((item) => {
        var _a;
        return (React.createElement("option", { key: item.key.toString(), value: item.key, disabled: (_a = item.disabled) !== null && _a !== void 0 ? _a : false }, item.value));
    })));
});
export default Select;
